import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5va6up922: FaireProductEntity = {
  token: "p_g5va6up922",
  type: "product",
  name: "Tipsy Turvy Jigger",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/2ca7e6d0614526c7939fd44c1964319c1f199736c3c1789116d53470dfb55b24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98d7801c27fa2c1c4fe806420bc28c3fe103455a0de21d69fec677c03a54656f.jpeg",
    "https://cdn.faire.com/fastly/6259a6e7f756908484088f5214dda80d9a4379e8979ea51d50b9467aca6fea10.jpeg"
  ],
  priceDollars: 8.5,
  description: "Your drink-making skills are about to soar. This Bando double shot glass features a two-tone design that’s as eye-catching as it is functional. Perfect for measuring, mixing, or simply showing off, it’s the kind of barware that deserves a spot on your kitchen counter or bar cart. Cheers to good taste (and good design).\n\nFeatures:\n\nDouble shot glass with a stylish two-tone design\n\nPerfect for cocktail mixing, measuring, or display\n\nDurable glass construction for everyday use\n\nCompact and easy to store or style on a bar cart\n\nDesigned in Bando’s signature playful, modern aesthetic\n\n\nIdeal For:\n\nGift shops and home décor boutiques\n\nLifestyle retailers and barware collections\n\nKitchen and entertaining stores\n\nWholesale buyers looking for fun, functional drinkware",
  tags: [],
  msrpDollars: 17.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:39.771Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
